(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-copyright"] && !Shopify.designMode) return;
  try {
    // Prevent duplicate footer rendering
  const existingFooters = document.querySelectorAll('.luxe-footer');
  if (existingFooters.length > 1) {
    // Remove all but the first footer
    for (let i = 1; i < existingFooters.length; i++) {
      existingFooters[i].remove();
    }
  }

  // Newsletter form submission
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const email = newsletterForm.querySelector('.newsletter-input').value;
      // Here you can add your newsletter signup logic
      // For now, just show an alert or integrate with Shopify's newsletter app
      console.log('Newsletter signup:', email);
      alert('Thank you for signing up!');
      newsletterForm.reset();
    });
  }

  // Currency selector
  const currencySelect = document.getElementById('currency-select');
  if (currencySelect) {
    // Load saved currency preference
    const savedCurrency = localStorage.getItem('luxe-currency') || 'KRW';
    currencySelect.value = savedCurrency;

    currencySelect.addEventListener('change', (e) => {
      const selectedCurrency = e.target.value;
      localStorage.setItem('luxe-currency', selectedCurrency);
      
      // Dispatch custom event for listings section to listen to
      window.dispatchEvent(new CustomEvent('currencyChanged', { 
        detail: { currency: selectedCurrency } 
      }));
    });
  }
  } catch(e) { console.error(e); }
})();

})();
